import React, { useState, useContext, useEffect } from "react";
import {
  DiaryCauseShape,
  DiaryCauseImage,
} from "../../utils/dairyDiamondsDetail";
import FcrfContext from "../../Context";

const DiaryColorCause = ({
  colorInfo,
  color,
  gia_report,
  data,
  sidebarCard,
  handleSideBarCard,
  isHide,
}) => {
  const { setPdfReportData } = useContext(FcrfContext);
  const [showFullText, setShowFullText] = useState(false);
  const [viewOnce, setViewOnce] = useState(false);

  const section = document.getElementById("colorCauseBoxAnimate");

  useEffect(() => {
    window.addEventListener("scroll", navHighlighter);
    return () => {
      window.removeEventListener("scroll", navHighlighter);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  function navHighlighter() {
    let scrollY = window.scrollY;
    let screenWidth = window.innerWidth;
    const sectionHeight = section?.offsetHeight;
    const sectionTop = section.getBoundingClientRect()?.top + (screenWidth > 767 ? -300 : 350);
    if (scrollY >= sectionTop && scrollY <= sectionTop + sectionHeight) {
      setViewOnce(true);
    }
  }

  const resultShape = DiaryCauseShape.filter(
    (elem) => gia_report?.results?.data?.shape?.shape_code === elem.code
  );
  const showShapeImg = resultShape[0]?.shape;
  const colorInfoText = colorInfo?.C18?.split("#") || [];
  const colorInfoText1 = colorInfo?.C20?.split("#") || [];

  const paraDetail =
    document?.getElementById("colorCauseText")?.getBoundingClientRect()
      ?.height || {};

  const resultCauseImage = DiaryCauseImage.filter(
    (elem) => elem.color === data?.color
  );
  const causeImage = resultCauseImage[0]?.img;
  
  useEffect(() => {
    const colorCauseBox = {
      heading: colorInfo?.B16,
      colorInfoText: colorInfoText?.length > 0 ? colorInfoText : null,
      colorInfoText1: colorInfoText1?.length > 0 ? colorInfoText1 : null,
      causeImg: causeImage,
    };

    // console.log("colorCauseBox", colorCauseBox);
    setPdfReportData((prev) => ({ ...prev, colorCauseBox }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [causeImage]);

  return (
    <section
      className={`diary-card ${sidebarCard?.colorCauseBox ? "show" : "hide"}`}
      id="colorCauseBox"
    >
      {!isHide && (
        <div className="mobile-hide-card-btn">
          <label className="diary-check-container">
            <input
              type="checkbox"
              id={`nav-colorCauseBox`}
              name={`colorCauseBox`}
              onChange={() =>
                handleSideBarCard("colorCauseBox", sidebarCard?.colorCauseBox)
              }
              checked={sidebarCard?.colorCauseBox}
            />
            <div className="checkmark"></div>
          </label>
        </div>
      )}
      <h4>{colorInfo?.B16}</h4>
      <div className="diary-card-content colorCause-card-content">
        <div className="colorCause-card-text">
          <p>
            {colorInfoText[0]} <b>{colorInfoText[1]}</b> {colorInfoText[2]}{" "}
            <b>{colorInfoText[3]}</b> {colorInfoText[4]}{" "}
            <b>{colorInfoText[5]}</b> {colorInfoText[6]}{" "}
            <b>{colorInfoText[7]}</b> {colorInfoText[8]}{" "}
            <b>{colorInfoText[9]}</b> {colorInfoText[10]}{" "}
            <b>{colorInfoText[11]}</b> {colorInfoText[12]}{" "}
            <b>{colorInfoText[13]}</b> {colorInfoText[14]}
          </p>
          <div
            className="dec-para-cause"
            style={{ height: `${showFullText ? `${paraDetail}px` : "0px"}` }}
          >
            <p id="colorCauseText">
              {colorInfoText1[0]} <b>{colorInfoText1[1]}</b> {colorInfoText1[2]}{" "}
              <b>{colorInfoText1[3]}</b> {colorInfoText1[4]}{" "}
              <b>{colorInfoText1[5]}</b> {colorInfoText1[6]}{" "}
              <b>{colorInfoText1[7]}</b> {colorInfoText1[8]}{" "}
              <b>{colorInfoText1[9]}</b> {colorInfoText1[10]}{" "}
              <b>{colorInfoText1[11]}</b> {colorInfoText1[12]}{" "}
              <b>{colorInfoText1[13]}</b> {colorInfoText1[14]}
            </p>
          </div>
          {!!colorInfo?.C20 && (
            <span
              className="readmore-text"
              onClick={() => setShowFullText(!showFullText)}
            >
              {showFullText ? "Read Less" : "Read More..."}
            </span>
          )}
        </div>
        
        <div className={`color-cause-diamond-bg ${viewOnce ? "animate" : ""}`} id="colorCauseBoxAnimate">
          {resultCauseImage.length > 0 ? (
            <img src={`/causeColorImg/${causeImage}`} alt={causeImage} />
          ) : (
            <>
              {showShapeImg === "Cushion" ? (
                <CauseCushion color={color} />
              ) : showShapeImg === "Emerald" ? (
                <CauseEmerald color={color} />
              ) : showShapeImg === "Heart" ? (
                <CauseHeart color={color} />
              ) : showShapeImg === "Marquise" ? (
                <CauseMarquise color={color} />
              ) : showShapeImg === "Oval" ? (
                <CauseOval color={color} />
              ) : showShapeImg === "Pear" ? (
                <CausePear color={color} />
              ) : showShapeImg === "Radiant" ? (
                <CauseRadiant color={color} />
              ) : showShapeImg === "Round" ? (
                <CauseRound color={color} />
              ) : (
                showShapeImg
              )}
            </>
          )}
        </div>
     
      </div>
    </section>
  );
};

export default DiaryColorCause;

const CauseCushion = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 9.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(12.062 18.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(9.875 9.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(23 11.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(19.937 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 21.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(7.875 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="m18.214 22.844 2.516-2.5 4.984-3.944-7.5 6.444zM8.056 8.774l-.968.876-.278.252-1.232.603-1.532.75 4.01-2.482zm-.574.814.877-.795.634-.574h1.426L7.482 9.59zm8.021-1.369L12.49 9.617l-1.322-1.398h4.335zm5.33 0L19.51 9.617l-3.014-1.398h4.336zm7.14 3.045-.957-.469-1.826-.893-.633-.573-.64-.58 4.056 2.515zm-16.679 9.104 2.491 2.475-7.47-6.418 4.98 3.943zM23.007 8.219l1.512 1.37-2.917-1.36-.021-.01h1.426zm-20.79 4.627h1.704v-.412H2.218v.412zm1.774-.632H2.583l3.492-1.708-2.084 1.708zm2.834-2.04.814 2.04H4.337l1.138-.933 1.35-1.107zm2.485 1.192-1.454.802-.845-2.118 3.878-1.808 1.398 1.48-2.977 1.644zM19.32 9.77 16 12.188l-.499-.363L12.68 9.77 16 8.23l3.32 1.54zm5.67.28-.845 2.118-4.432-2.446 1.399-1.48 3.878 1.808zm2.674 2.164h-3.302l.813-2.04 1.183.97 1.306 1.07zm.344 0-.925-.759-1.157-.95 3.491 1.71h-1.409zm-5.424 6.278 5.431-5.426h1.561l-7.505 5.937.513-.511zm-4.796 1.898 5.965-6.761-3.187 6.568-4.29 4.265 1.512-4.072zm-3.367-.065 1.58-6.881 1.577 6.881L16 24.576l-.932-2.508-.647-1.743zM10 17.227l-1.75-3.595 5.963 6.758 1.512 4.072-4.267-4.24L10 17.226zm-5.705-4.161h3.437l3.252 6.683-6.538-6.533-.151-.15zm-.31 0 4.13 4.125 1.833 1.832-7.524-5.957h1.561zm.154-.22h3.552v-.412H4.139v.412zm15.749-2.778 3.887 2.146H20.51l-.776-2.232.155.086zm4.422 2.778h3.551v-.412H24.31v.412zm-3.047 6.416 3.006-6.196h3.436l-6.667 6.661.225-.465zM7.91 12.846h3.551v-.412H7.91v.412zm3.582-.632H8.225l4.042-2.23-.776 2.23zm.232 0 .796-2.29 3.145 2.29h-3.94zm-.045.632h4.213v-.412h-4.213v.412zm8.862 0h3.552v-.412H20.54v.412zM18 19.82l2.507-6.753h3.451l-.111.126L18 19.819zm-.283.134-1.58-6.887h4.137l-2.557 6.887zm-6.224-6.887L14 19.819l-5.958-6.753h3.451zm1.503 3.42-1.27-3.42h4.137l-1.58 6.887-1.287-3.466zm3.341-4.272 3.145-2.29.795 2.29h-3.94zm-.227.632h4.212v-.412H16.11v.412zm11.969 0h1.703v-.412h-1.703v.412zm1.912-.558a.154.154 0 0 0-.043-.057l-6.796-4.215A.337.337 0 0 0 23.049 8H8.95c-.009 0-.015.007-.023.01-.029-.004-.058-.007-.08.006l-6.796 4.215a.138.138 0 0 0-.052.093v.632c0 .011.028.075.038.083L15.93 24.974A.138.138 0 0 0 16 25a.07.07 0 0 0 .048-.018c.007-.003.017-.003.023-.008l.002-.002.013-.01 13.876-11.923a.272.272 0 0 0 .038-.083v-.632a.09.09 0 0 1-.01-.036z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseEmerald = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(5.75 15.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 13.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 16.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 14.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.375 10.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.062 11.94)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 12.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 12.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(25.437 14.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 15.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(23 11.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(24.187 18.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.187 15.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(4.875 11.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 18.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.875 17.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.875 17.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.875 20.414)"
          />
        </g>
        <path
          d="M2.217 12.727h1.944l-.643 1.052h-2.18l.879-1.052zm1.294-1.277h1.56l-.773 1.066H2.425l1.086-1.066zm24.205 1.066-.773-1.066H28.5l1.018 1.066h-1.802zm.78 1.263-.643-1.052h1.864l.936 1.052h-2.157zm.017 2.84H26.3l2.291-2.096h2.04l-2.118 2.096zm-3.73 2.889h-1.64l2.927-2.678h2.178l-3.464 2.678zm-1.87.21h1.472l-3.351 1.72 1.879-1.72zM11.678 21.79l-2.263-2.072h13.181l-2.264 2.072h-8.654zm-2.58-2.072 1.893 1.732-3.377-1.732h1.484zM5.943 16.83l2.925 2.678H7.216L3.743 16.83h2.2zm-2.52-2.307 2.29 2.096H3.478l-2.11-2.096h2.055zm-.052-.505c0 .02-.005.037-.015.054v.24H1.22v-.323h2.17l-.018.029zm22.382 2.812-2.926 2.678H9.185L6.259 16.83h19.494zM6.03 16.62l-2.29-2.097h24.535l-2.29 2.096H6.028zm24.752-2.307h-2.124v-.241a.102.102 0 0 1-.015-.054l-.018-.029h2.157v.324zm-2.41-.324.068.111v.213H3.575V14.1l.068-.11H28.37zM4.414 12.727H27.6l.643 1.052H3.772l.643-1.052zm22.26-1.277.774 1.066H4.565l.773-1.066h21.338zm.098-1.24 1.444 1.03H26.79l-.08-.111-.002-.001-.69-.918h.755zm-1.025 0 .775 1.03H5.491l.775-1.03h19.482zm-20.521 0h.77l-.691.917-.002.002-.08.11h-1.43l1.433-1.029zM1.03 14.491l2.322 2.307.007.004c.001 0 0 .004.003.005l3.746 2.888a.02.02 0 0 1 .016.01l4.448 2.283a.111.111 0 0 0 .051.012h8.751a.116.116 0 0 0 .052-.012l4.448-2.282a.019.019 0 0 1 .016-.011l3.736-2.888.004-.005a.019.019 0 0 1 .006-.004l2.332-2.307.031-.073v-.534a.54.54 0 0 1-.027-.069l-1.123-1.262c-.002 0-.002-.001-.002-.003l-.004-.003-1.215-1.273a.323.323 0 0 0-.016-.014l-1.74-1.24a.237.237 0 0 1-.064-.02H5.191a.228.228 0 0 1-.065.02L3.4 11.26a.2.2 0 0 1-.012.012l-1.302 1.276c0 .004-.003.007-.007.008l-1.055 1.262a.31.31 0 0 1-.024.066v.534l.03.073z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseHeart = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.25 23.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 9.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(12.062 18.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.875 7.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(24.437 7.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.437 8.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(25 10.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 10.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.937 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.937 7.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 21.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.187 23.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(6.875 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="m24.867 20.897-3.735 3.422 7.63-10.484-3.895 7.062zM7.237 6.807l1.375-.588h2.603l-3.977.588zm8.098.118-1.997-.706h5.005l-3.008.706zm9.25-.706.261.343-.345-.343h.083zm5.031 5.172h-1.379L26.4 8.378l3.216 3.013zM19.56 23.56l7.561-9.9-6.79 11.39-2.167 1.52 1.396-3.01zM4.827 12.21l7.85 9.785-9.316-9.785h1.466zm19.087-5.787-.746 1.195-3.339-1.4h4.213l-.128.205zm5.87 5.568h-1.5v-.382h1.5v.382zm-.156.219-7.883 10.889 6.492-10.889h1.391zm-18.87.934 4.429 7.742 1.867 3.265.65 2.436-3.253-2.733-3.694-10.71zM4.801 11.39H3.323L6.09 7.665 4.802 11.39zM15.12 7.08l-4.825 4.265-3.662-4.228 6.058-.896 1.89.667.539.191zm9.454 4.91v-.382h3.497v.382h-3.497zm-7.44 11.592L14.268 12.21h4.757l-1.894 11.373zM10.206 12.21l3.847 11.156-8.95-11.156h5.103zm-5.221-.219h5.19v-.382h-5.19v.382zm5.06-.6H5.03l1.43-4.14 3.586 4.14zm9.117-.046-3.635-4.24 3.75-.88L23.01 7.79l-3.848 3.555zm.099.646h5.097v-.382h-5.097v.382zm5.27.219h3.425l-8.03 10.513 4.606-10.513zm-4.97 10.809-.299-10.809h5.035L19.56 23.019zm-5.325-11.028h4.81v-.382h-4.81v.382zm-.19.219 2.811 11.165-6.387-11.165h3.577zm0-.82h-3.476l4.56-4.032-1.083 4.033zm1.333-4.126 3.538 4.127H14.27l1.11-4.127zm-4.989 4.727h3.631v-.382h-3.63v.382zm13.925-.6h-4.883l3.728-3.443 1.155 3.443zm3.537 0h-3.31l-1.12-3.34 4.43 3.34zm-4.499-3.664.903-1.445 1.552 1.542 1.981 3.248-4.436-3.345zm-4.278 5.489.283 10.263-1.436 3.097-.66-2.473 1.813-10.887zM3.215 11.991H4.77v-.382H3.215v.382zM30 11.501c0-.017-.074-.116-.035-.08l-3.992-3.74-1.251-1.639L24.637 6H8.59a.103.103 0 0 0-.04.009l-2.17.929a.106.106 0 0 0-.045.035l-3.312 4.461A.243.243 0 0 1 3 11.5v.6l.03.077 11.252 11.817a.012.012 0 0 1 .009.009l3.535 2.97h.001v.001c.024.002.044.01.06.025a.11.11 0 0 0 .07-.018l2.514-1.763c.002-.004.005-.008.01-.009l4.543-4.161a.106.106 0 0 0 .022-.029l4.73-8.58.19-.26.005-.007.005-.006a.185.185 0 0 0 .023-.069v-.594L30 11.5z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseMarquise = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 17.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.375 11.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.062 12.94)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(23 12.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 12.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 17.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.187 16.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(6.875 12.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="M5.558 15.54 9.63 17.31l3.399 1.976-7.472-3.744zm2.069-3.856-.8.423-1.795.512 2.595-.935zm7.666-.477-1.136.342-1.329.398-1.275-.64-.2-.1h3.94zm5.353 0-.2.1-1.275.64-2.443-.734-.021-.006h3.94zm1.724 6.102 4.07-1.767-7.47 3.744 3.4-1.977zM7.755 11.854l1.225-.647h1.155l-2.38.647zm17.418.253-.845-.446 2.694.974-1.85-.528zm2.906 1.72h1.702v-.162H28.08v.162zM17.36 18.734l.246-.43 6.284-4.048-.367.64-1.286 2.247-5.946 3.457 1.069-1.866zm-14.75-4.7H4l4.084 2.375-5.106-2.216-.367-.16zm-.392-.207h1.703v-.162H2.218v.162zm9.385-1.513L7.846 13.44l-.264-.386-.539-.79 3.858-1.048 1.634.82-.932.28zm5.587.57-1.19.562-2.892-1.365L16 11.212l2.892.869-1.702.803zm7.767-.62-.157.23-.646.945-4.69-1.404 1.635-.82 3.858 1.049zm3.039 1.194-1.234-.59-.47-.225 2.856.815h-1.152zm-.039.6.043-.024h1.39l-5.475 2.375 4.042-2.35zm-5.347 2.867 1.655-2.891h3.318l-1.456.846-3.517 2.045zm-8.014 1.298L16 14.256l1.404 3.967-1.382 2.413-.022.038-1.404-2.45zM4.004 13.458H2.852l2.855-.814-1.703.814zm3.594 0H4.49l2.343-1.12.368.538.397.582zm.31.369h3.995v-.162H7.908v.162zm4.037-.369H8.51l4.093-1.225-.657 1.225zm.245 0 .676-1.26 2.67 1.26H12.19zm-.069.369h3.77v-.162h-3.77v.162zm7.688-.369h-3.344l2.669-1.26.675 1.26zm.246 0-.657-1.225 4.092 1.225h-3.435zm.042.369h3.994v-.162h-3.994v.162zm5.07-1.49 2.343 1.121H24.4l.398-.582.368-.539zm-.858 1.49h3.551v-.162h-3.55v.162zm-6.474 4.08 1.766-3.085.452-.788h3.792l-6.01 3.872zm-10.1-3.873 1.655 2.891-4.972-2.891h3.316zm-3.596-.207H7.69v-.162H4.14v.162zm7.808.207 2.219 3.873-6.01-3.873h3.791zm5.6 3.94-.305-.86-1.09-3.08h3.652l-1.151 2.01-1.106 1.93zm-1.437-4.147h3.77v-.162h-3.77v.162zm-3.914.207h3.652l-1.395 3.94-1.263-2.206-.994-1.734zM15.71 20.6l-5.946-3.457-1.653-2.887 6.284 4.048.297.519L15.71 20.6zm7.311-9.393.189.1 1.036.547-2.38-.647h1.155zM30 13.562c0-.035-.036-.085-.07-.097l-6.797-2.458A.495.495 0 0 0 23.05 11H8.952c-.015 0-.027.004-.04.01-.015 0-.031-.008-.046-.003L2.07 13.465c-.034.012-.07.062-.07.097v.368c0 .03.03.078.058.091l13.891 6.962c.064.031.034.01.065.008.013-.001.025-.003.037-.008l13.89-6.962a.127.127 0 0 0 .059-.09v-.37z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseOval = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 9.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(12.062 18.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(9.875 9.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(23 11.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(19.937 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 21.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(7.875 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="m18.214 22.844 2.516-2.5 4.984-3.944-7.5 6.444zM8.056 8.774l-.968.876-.278.252-1.232.603-1.532.75 4.01-2.482zm-.574.814.877-.795.634-.574h1.426L7.482 9.59zm8.021-1.369L12.49 9.617l-1.322-1.398h4.335zm5.33 0L19.51 9.617l-3.014-1.398h4.336zm7.14 3.045-.957-.469-1.826-.893-.633-.573-.64-.58 4.056 2.515zm-16.679 9.104 2.491 2.475-7.47-6.418 4.98 3.943zM23.007 8.219l1.512 1.37-2.917-1.36-.021-.01h1.426zm-20.79 4.627h1.704v-.412H2.218v.412zm1.774-.632H2.583l3.492-1.708-2.084 1.708zm2.834-2.04.814 2.04H4.337l1.138-.933 1.35-1.107zm2.485 1.192-1.454.802-.845-2.118 3.878-1.808 1.398 1.48-2.977 1.644zM19.32 9.77 16 12.188l-.499-.363L12.68 9.77 16 8.23l3.32 1.54zm5.67.28-.845 2.118-4.432-2.446 1.399-1.48 3.878 1.808zm2.674 2.164h-3.302l.813-2.04 1.183.97 1.306 1.07zm.344 0-.925-.759-1.157-.95 3.491 1.71h-1.409zm-5.424 6.278 5.431-5.426h1.561l-7.505 5.937.513-.511zm-4.796 1.898 5.965-6.761-3.187 6.568-4.29 4.265 1.512-4.072zm-3.367-.065 1.58-6.881 1.577 6.881L16 24.576l-.932-2.508-.647-1.743zM10 17.227l-1.75-3.595 5.963 6.758 1.512 4.072-4.267-4.24L10 17.226zm-5.705-4.161h3.437l3.252 6.683-6.538-6.533-.151-.15zm-.31 0 4.13 4.125 1.833 1.832-7.524-5.957h1.561zm.154-.22h3.552v-.412H4.139v.412zm15.749-2.778 3.887 2.146H20.51l-.776-2.232.155.086zm4.422 2.778h3.551v-.412H24.31v.412zm-3.047 6.416 3.006-6.196h3.436l-6.667 6.661.225-.465zM7.91 12.846h3.551v-.412H7.91v.412zm3.582-.632H8.225l4.042-2.23-.776 2.23zm.232 0 .796-2.29 3.145 2.29h-3.94zm-.045.632h4.213v-.412h-4.213v.412zm8.862 0h3.552v-.412H20.54v.412zM18 19.82l2.507-6.753h3.451l-.111.126L18 19.819zm-.283.134-1.58-6.887h4.137l-2.557 6.887zm-6.224-6.887L14 19.819l-5.958-6.753h3.451zm1.503 3.42-1.27-3.42h4.137l-1.58 6.887-1.287-3.466zm3.341-4.272 3.145-2.29.795 2.29h-3.94zm-.227.632h4.212v-.412H16.11v.412zm11.969 0h1.703v-.412h-1.703v.412zm1.912-.558a.154.154 0 0 0-.043-.057l-6.796-4.215A.337.337 0 0 0 23.049 8H8.95c-.009 0-.015.007-.023.01-.029-.004-.058-.007-.08.006l-6.796 4.215a.138.138 0 0 0-.052.093v.632c0 .011.028.075.038.083L15.93 24.974A.138.138 0 0 0 16 25a.07.07 0 0 0 .048-.018c.007-.003.017-.003.023-.008l.002-.002.013-.01 13.876-11.923a.272.272 0 0 0 .038-.083v-.632a.09.09 0 0 1-.01-.036z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CausePear = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 9.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.062 12.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(9.875 9.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(22 11.07)" />
          <circle cx=".435" cy=".414" r="1" transform="translate(26 13.07)" />
          <circle cx=".435" cy=".414" r="1" transform="translate(4 13.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(19.937 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.187 20.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(7.875 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="m8.764 9.494-4.628 1.667 5.542-2.717-.914 1.05zm.442-.175.958-1.101h1.804L9.206 9.319zm7.746.11-3.727-1.211h6.673l-2.946 1.21zm6.868-.03-2.825-1.181h3.248l-.423 1.18zm5.638 2.525-.752-.942.926.942h-.174zm0 .955h.197l-3.845 4.515 3.648-4.515zm-23.74 0 12.948 9.82L2.5 12.879h3.219zm-3.5-.218h10.21v-.518H2.217v.518zm3.499-.737H2.662l5.58-2.01-2.525 2.01zm6.455 0H6.066l2.767-2.202 3.34 2.202zm.369-.018L9.062 9.612l3.479-1.388 4.145 1.347-4.145 2.335zm7.91-.007-3.27-2.33 3.27-1.342 3.211 1.343-3.212 2.329zm6.86-.076-3.297-2.32.446-1.244 2.851 1.354v2.21zm.219.101V9.856l1.649 2.068h-1.65zm-.045.955h1.692l-5.062 6.266 3.37-6.266zm-11.02 7.877-3.42-7.175 6.11 7.658 1 2.315-3.69-2.798zm-3.997-7.877 3.62 7.59-10.01-7.59h6.39zm.177-.218h7.697v-.518h-7.697v.518zm4.349-2.956 3.115 2.22h-4.316l1.2-2.22zm-1.449 2.22h-2.592l3.728-2.1-1.136 2.1zm9.353 0h-4.111l3.055-2.216 1.056 2.215zm.226 0c-.001-.013.004-.025-.002-.037l-.961-2.015 2.915 2.051h-1.952zm-4.564.736h6.751v-.518H20.56v.518zm-.133.85 1.16 7.303-1.168 2.799-1.058-2.446 1.066-7.656zm-4.65-.632h4.517l-1.1 7.902-3.418-7.902zm-.238 0 3.284 7.596-6.06-7.596h2.776zm6.207 7.551-1.198-7.551h4.348l-3.15 7.551zm3.378-7.551h2.085l-5.033 7.087 2.948-7.067c.003-.006 0-.013 0-.02zm-4.31 10.352.98-2.35 4.699-6.616-3.118 5.796-2.56 3.17zm6.716-10.57h2.252v-.518H27.53v.518zm-1.535-4.443.972.99-2.085-.99h1.113zM2.02 12.82l.032.043 18.312 11.122c.043.026.083.016.119-.013.006-.005.015-.003.02-.01l9.471-11.121A.567.567 0 0 1 30 12.77v-.737a3.921 3.921 0 0 1-.03-.076l-3.851-3.925L26.04 8H10.114l-.048.01-8.005 3.925a.157.157 0 0 0-.061.098v.737l.02.05z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseRadiant = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 6.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.062 12.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(9.875 8.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(22 11.07)" />
          <circle cx=".435" cy=".414" r="1" transform="translate(26 13.07)" />
          <circle cx=".435" cy=".414" r="1" transform="translate(5 12.07)" />
          <circle cx=".435" cy=".414" r="1" transform="translate(14 22.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(19.937 8.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.937 8.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(26.937 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(12.937 11.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.187 20.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(7.875 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="M4.946 7.68h2.766L6.89 8.9l-.426.632H3.341L4.946 7.68zm4.01-1.468h6.297L7.97 7.457l-.679-1.245h1.664zm18.282.588-.779-.588h.258l.52.588zm-.792 2.732L25.338 7.89l-.142-.21h2.821l1.639 1.852h-3.21zm-20 .827 1.133 3.309-1.077 1.116-1.42-.792-1.802-3.633h3.165zm-3.231-.212h3.2v-.404h-3.2v.404zM7.97 7.68h16.968l1.25 1.852H6.722l.402-.597.845-1.255zm15.79-.212H9.16l7.34-1.255 7.26 1.255zm2.402-1.214 1.607 1.214h-2.555l.948-1.214zM25 7.395l-.842-1.183h1.766L25 7.395zm1.495 2.752h3.29v-.404h-3.29v.404zm-.036 4.851 1.2-.67-1.36 2.743-4.162 3.67 4.322-5.743zm-9.898 7.895 9.233-7.367-4.454 5.917-4.779 4.214v-2.764zm-8.84-9.066 5.2 2.873 3.178 5.722-9.419-7.515 1.042-1.08zm18.515-3.468-1.118 3.263-5.256 2.903-3.408 1.229-3.409-1.229-5.255-2.903-1.118-3.263h19.564zm-6.249 6.34 5.2-2.872 1.041 1.08-9.419 7.515 3.178-5.722zm-3.64 5.73-3.116-5.611 3.116 1.122v4.489zm.214-4.489 3.116-1.122-3.116 5.61V17.94zm11.266-3.949-1.42.793-1.077-1.116 1.133-3.31h3.165l-1.801 3.633zM6.629 10.147h19.65v-.403H6.629v.403zm17.267-3.935.766 1.077.098.137-7.024-1.214h6.16zm-16.822.047.659 1.21h-2.47l1.81-1.21zm-.855-.047h.543l-1.266.845.723-.845zm.39 10.859-1.36-2.743 1.2.67 4.321 5.742-4.16-3.669zm4.958 4.372-4.453-5.917 9.233 7.367v2.764l-4.78-4.214zM29.973 9.568l-1.787-2.02a.106.106 0 0 0-.035-.058l-.052-.04-1.252-1.414A.109.109 0 0 0 26.766 6H6.169a.295.295 0 0 0-.081.037L3.025 9.57A.137.137 0 0 1 3 9.638v.615a.08.08 0 0 1 .011.047l3.415 6.883c.002.005.01.004.013.008.004.008.004.017.011.024l9.932 8.758c.048.036.096.036.144 0l9.934-8.758c.006-.006.006-.016.011-.023.003-.005.01-.004.013-.008l3.504-6.884a.078.078 0 0 1 .012-.047v-.615a.15.15 0 0 1-.027-.07z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};

const CauseRound = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(10.75 16.869)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(14.25 14.384)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(11.625 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(13.375 9.828)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(12.062 18.94)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(9.875 9.414)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(7.25 13.97)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(20.812 13.97)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(23.437 15.627)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 16.455)"
          />
          <circle cx=".435" cy=".414" r="1" transform="translate(23 11.07)" />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(17.312 11.485)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(19.937 9.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 19.768)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(18.187 21.425)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(7.875 10.414)"
          />
          <circle
            cx=".435"
            cy=".414"
            r="1"
            transform="translate(15.875 19.414)"
          />
        </g>
        <path
          d="m18.214 22.844 2.516-2.5 4.984-3.944-7.5 6.444zM8.056 8.774l-.968.876-.278.252-1.232.603-1.532.75 4.01-2.482zm-.574.814.877-.795.634-.574h1.426L7.482 9.59zm8.021-1.369L12.49 9.617l-1.322-1.398h4.335zm5.33 0L19.51 9.617l-3.014-1.398h4.336zm7.14 3.045-.957-.469-1.826-.893-.633-.573-.64-.58 4.056 2.515zm-16.679 9.104 2.491 2.475-7.47-6.418 4.98 3.943zM23.007 8.219l1.512 1.37-2.917-1.36-.021-.01h1.426zm-20.79 4.627h1.704v-.412H2.218v.412zm1.774-.632H2.583l3.492-1.708-2.084 1.708zm2.834-2.04.814 2.04H4.337l1.138-.933 1.35-1.107zm2.485 1.192-1.454.802-.845-2.118 3.878-1.808 1.398 1.48-2.977 1.644zM19.32 9.77 16 12.188l-.499-.363L12.68 9.77 16 8.23l3.32 1.54zm5.67.28-.845 2.118-4.432-2.446 1.399-1.48 3.878 1.808zm2.674 2.164h-3.302l.813-2.04 1.183.97 1.306 1.07zm.344 0-.925-.759-1.157-.95 3.491 1.71h-1.409zm-5.424 6.278 5.431-5.426h1.561l-7.505 5.937.513-.511zm-4.796 1.898 5.965-6.761-3.187 6.568-4.29 4.265 1.512-4.072zm-3.367-.065 1.58-6.881 1.577 6.881L16 24.576l-.932-2.508-.647-1.743zM10 17.227l-1.75-3.595 5.963 6.758 1.512 4.072-4.267-4.24L10 17.226zm-5.705-4.161h3.437l3.252 6.683-6.538-6.533-.151-.15zm-.31 0 4.13 4.125 1.833 1.832-7.524-5.957h1.561zm.154-.22h3.552v-.412H4.139v.412zm15.749-2.778 3.887 2.146H20.51l-.776-2.232.155.086zm4.422 2.778h3.551v-.412H24.31v.412zm-3.047 6.416 3.006-6.196h3.436l-6.667 6.661.225-.465zM7.91 12.846h3.551v-.412H7.91v.412zm3.582-.632H8.225l4.042-2.23-.776 2.23zm.232 0 .796-2.29 3.145 2.29h-3.94zm-.045.632h4.213v-.412h-4.213v.412zm8.862 0h3.552v-.412H20.54v.412zM18 19.82l2.507-6.753h3.451l-.111.126L18 19.819zm-.283.134-1.58-6.887h4.137l-2.557 6.887zm-6.224-6.887L14 19.819l-5.958-6.753h3.451zm1.503 3.42-1.27-3.42h4.137l-1.58 6.887-1.287-3.466zm3.341-4.272 3.145-2.29.795 2.29h-3.94zm-.227.632h4.212v-.412H16.11v.412zm11.969 0h1.703v-.412h-1.703v.412zm1.912-.558a.154.154 0 0 0-.043-.057l-6.796-4.215A.337.337 0 0 0 23.049 8H8.95c-.009 0-.015.007-.023.01-.029-.004-.058-.007-.08.006l-6.796 4.215a.138.138 0 0 0-.052.093v.632c0 .011.028.075.038.083L15.93 24.974A.138.138 0 0 0 16 25a.07.07 0 0 0 .048-.018c.007-.003.017-.003.023-.008l.002-.002.013-.01 13.876-11.923a.272.272 0 0 0 .038-.083v-.632a.09.09 0 0 1-.01-.036z"
          fill="#3A4564"
        />
      </g>
    </svg>
  );
};
